import { CustomerAPI } from './API'
import {
  CreateCustomerPayload,
  CreateCustomerResponseDTO,
} from './dtos/customer'

export class CustomerStore {
  constructor(private readonly customerAPI: CustomerAPI) {}

  async create(
    payload: CreateCustomerPayload,
  ): Promise<CreateCustomerResponseDTO> {
    return this.customerAPI.create(payload)
  }
}
